import { Component } from '@angular/core';

@Component({
  selector: 'ngx-packery-item',
  template: `<ng-content></ng-content>`,
  styles: []
})
export class NgxPackeryItemComponent {}
